const variants = {
  outline: {
    backgroundColor: `gray.75`,
    borderColor: 'gray.75',
    color: `heading`,
    _hover: {
      borderColor: `gray.200`,
    },
    _focus: {
      borderColor: `gray.200`,
    },
  },
};
export const PinInput = {
  variants,
};
